import { jsxs as P, Fragment as I, jsx as a } from "react/jsx-runtime";
import { Box as T, Stack as L, Typography as d, Select as A, MenuItem as z, Pagination as D, PaginationItem as K, TablePagination as M } from "@mui/material";
import { u as B } from "../../../chunks/TableContext.js";
import { PaginationActions as F } from "./PaginationActions.js";
import { styles as o } from "./styles.js";
import { useRef as j, useEffect as k } from "react";
import O from "@mui/icons-material/KeyboardDoubleArrowLeft";
import _ from "@mui/icons-material/KeyboardDoubleArrowRight";
import E from "@mui/icons-material/KeyboardArrowLeft";
import H from "@mui/icons-material/KeyboardArrowRight";
function Z() {
  const {
    table: c,
    data: r,
    enableVirtualization: p,
    pageSize: n = 10,
    setPageSize: b = () => {
    },
    currentPage: i = 0,
    setCurrentPage: s = () => {
    },
    hideRowsPerPageSelector: C = !1,
    disablePagination: g = !1,
    rowsPerPageOptions: h = [],
    isManualPagination: l,
    onPaginationChange: x,
    onRowsPerPageChange: y,
    totalPages: f,
    currentRowsPerPage: w,
    footerLeftComponent: u
  } = B(), R = j(r.length);
  if (k(() => {
    if (l || p) return;
    if (R.current !== r.length) {
      R.current = r.length;
      const t = Math.ceil(c.getRowCount() / n);
      !g && t > 0 && i >= t && s(t - 1);
    }
  }, [n, s, g, l, p, r.length]), g || p)
    return null;
  const S = l ? f : Math.ceil(c.getRowCount() / n), m = C || h.length === 0;
  return /* @__PURE__ */ P(T, { sx: o.paginationContainer, children: [
    u && (typeof u == "function" ? u({
      pageSize: n ?? 0,
      currentPage: i ?? 0,
      totalPages: f ?? 0,
      currentRowsPerPage: w ?? 0
    }) : u),
    !g && (l ? /* @__PURE__ */ P(L, { sx: o.rowsPerPageStack, children: [
      !m && /* @__PURE__ */ P(I, { children: [
        /* @__PURE__ */ a(d, { sx: o.rowsPerPageText, children: "Rows per page:" }),
        /* @__PURE__ */ a(A, { sx: o.rowsPerPageSelect, variant: "outlined", value: w || 10, onChange: (e) => {
          y?.(Number(e.target.value));
        }, children: h?.map((e) => /* @__PURE__ */ a(z, { value: e, children: e }, e)) })
      ] }),
      /* @__PURE__ */ a(D, { count: S, page: i, sx: o.paginationStyle, onChange: (e, t) => x?.(t), size: "small", shape: "rounded", variant: "outlined", showFirstButton: !0, showLastButton: !0, siblingCount: 1, boundaryCount: 1, renderItem: (e) => /* @__PURE__ */ a(K, { slots: {
        first: O,
        last: _,
        previous: E,
        next: H
      }, ...e }) })
    ] }) : /* @__PURE__ */ a(M, { component: "div", count: c.getRowCount(), page: i, onPageChange: (e, t) => s(t), rowsPerPage: n, onRowsPerPageChange: (e) => {
      b(parseInt(e.target.value, 10)), s(0);
    }, rowsPerPageOptions: m ? [] : h, ActionsComponent: F, sx: o.tablePagination, labelDisplayedRows: ({
      from: e,
      to: t,
      count: v
    }) => /* @__PURE__ */ P(d, { component: "span", sx: o.paginationText, children: [
      "Rows: ",
      e,
      "–",
      t,
      " of ",
      v
    ] }), labelRowsPerPage: m ? null : /* @__PURE__ */ a(d, { component: "span", sx: o.paginationRowsPerPageText, children: "Rows per page:" }) }))
  ] });
}
export {
  Z as TableFooter
};
